import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      transform="scale(1.5 1.5)"
      d="M13.1733 11.1266L6 9.33323V3.9999L13.1733 2.20657C13.2732 2.18184 13.3773 2.18055 13.4778 2.20278C13.5782 2.22501 13.6721 2.27018 13.7521 2.33474C13.8322 2.39929 13.8962 2.4815 13.9392 2.57492C13.9822 2.66834 14.003 2.77044 14 2.87323V10.4799C13.9999 10.581 13.9768 10.6808 13.9325 10.7717C13.8882 10.8626 13.8237 10.9422 13.7441 11.0045C13.6644 11.0668 13.5717 11.1102 13.4728 11.1313C13.3739 11.1525 13.2715 11.1508 13.1733 11.1266ZM6 3.9999H4.66667C3.95942 3.9999 3.28115 4.28085 2.78105 4.78095C2.28095 5.28105 2 5.95932 2 6.66657V6.66657C2 7.37381 2.28095 8.05209 2.78105 8.55219C3.28115 9.05228 3.95942 9.33323 4.66667 9.33323H6V3.9999Z"
      stroke={fill}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      transform="scale(1.5 1.5)"
      d="M5.99994 9.33341V13.3334C5.99994 13.5102 5.9297 13.6798 5.80468 13.8048C5.67966 13.9298 5.51009 14.0001 5.33327 14.0001H4.54661C4.39064 14.0032 4.23852 13.9516 4.1167 13.8541C3.99489 13.7567 3.91111 13.6196 3.87994 13.4667L2.93994 8.66675"
      stroke={fill}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </g>
);

export default Icon;
